import { createStyles } from "antd-style";

export const useModalLicensesFormStyles = createStyles(({ css }: any) => ({
  drawer: css``,
}));
